import cn from 'classnames'
import style from './counter.module.scss'

const SizeMultiple = 8

export type SizeMultiplier = 2 | 2.25 | 2.5 | 3 | 3.5 | 4 | 6

type StyleOverrides = {
  minWidth?: string
  height?: string
  fontSize?: 'small' | 'normal'
}

interface CounterProps {
  alertCount: number | string
  multiplier?: SizeMultiplier
  ariaHidden?: boolean
  fontSize?: 'small' | 'normal'
  color?: 'goldOnYellow' | 'whiteOnRed' | 'whiteOnGold' | 'whiteOnCritical'
  qa?: string
}

export const Counter = ({
  multiplier = 3,
  alertCount,
  qa,
  fontSize,
  ariaHidden,
  color = 'goldOnYellow',
}: CounterProps) => {
  const size = SizeMultiple * multiplier
  const sizeInPx: StyleOverrides = { minWidth: `${size}px`, height: `${size}px` }

  return (
    <span
      className={cn(
        style.alertCount,
        fontSize === 'small' && style.alertCountSmall,
        color === 'whiteOnRed' && style.red,
        color === 'whiteOnGold' && style.gold,
        color === 'whiteOnCritical' && style.critical
      )}
      style={{ ...sizeInPx }}
      data-qa={qa}
      aria-hidden={ariaHidden}
    >
      {alertCount}
    </span>
  )
}

export const CounterWithBorder = (props: CounterProps) => {
  return (
    <span
      className={cn(
        style.alertCountBorder,
        props.color === 'whiteOnRed' && style.red,
        props.color === 'whiteOnCritical' && style.critical
      )}
    >
      <Counter {...props} />
    </span>
  )
}
